<!--
   @ 组件-流程信息块
-->
<template>
    <div style="width: 100%">
        <!-- <ul class="flow_chart">
            <li v-for="(item,i) in flowData.nodeList" :key="i"  :class="i<flowData.currentNode?'history activation':i==flowData.currentNode?'history activation current':''">
                <div>
                    <div :class="item.current?'yuan el-icon-check':'yuan'"></div>
                    <div class="jt"></div>
                    <span>{{item.elementName}}</span>
                </div>
            </li>
        </ul> -->
        <!-- <ul class="flow_chart">
            <li v-for="(item,i) in flowData.nodeList" :key="i"  :class="item.current ? 'history activation current': ((!item.current) && (item.auditHistorys === undefined || item.auditHistorys.length < 1)) ? '' : 'history activation'">
                <div>
                    <div :class="item.current?'yuan el-icon-check':'yuan'"></div>
                    <div class="jt"></div>
                    <span>{{item.elementName}}</span>
                </div>
            </li>
        </ul> -->
        <ul class="flow_chart">
            <li v-for="(item,i) in flowData.nodeList" :key="i" :class="currentNodeIndex==i?'current history':currentNodeIndex>=i?'history actived':''">
                <div>
                    <div :class="item.current||(currentNodeIndex>i) ?'yuan el-icon-check':'yuan'"></div>
<!--                    <div class="jt"></div>-->
                    <span>{{item.elementName}}</span>
                </div>
            </li>
        </ul>
        <el-table
                :data="tableData"
                stripe
                border
                v-loading="dataListLoading"
                style="width: 100%;">
            <el-table-column
                    type="index"
                    header-align="center"
                    align="center"
                    label="序号"
                    width="50">
            </el-table-column>
            <el-table-column
                    prop="taskName"
                    header-align="center"
                    align="center"
                    width="120"
                    label="任务名称">
            </el-table-column>
            <el-table-column
                    prop="userName"
                    header-align="center"
                    align="center"
                    width="150"
                    label="执行人姓名">
            </el-table-column>
            <el-table-column
                    prop="excuteDate"
                    header-align="center"
                    align="center"
                    width="180"
                    label="执行人时间">
            </el-table-column>
            <el-table-column
                    prop="auditMsg"
                    header-align="center"
                    align="center"
                    label="审核意见">
            </el-table-column>
        </el-table>
    </div>
</template>
<script>
    export default {
        props:['flowData','tableData'],
        data() {
            return {
                dataListLoading:false,
                currentNodeIndex:"",//判断返回节点的current字段哪个为true
            };
        },
        created(){
            this.getLastNode();
        },
        activated(){
            this.getLastNode();
        },
        watch:{
            flowData:{
                handler(newV, oldV){
                    this.getLastNode()
                },
                deep:true
            }
        },
        methods: {
            getLastNode(){
                for(var i in this.flowData.nodeList){
                    if(this.flowData.nodeList[i].current){
                        this.currentNodeIndex=i;
                        break;
                    }
                }
            }
        },
    };
</script>
<style lang="scss">
    .flow_chart{
        height: 100px;
        margin: 10px 0 -44px;
        display: flex;
        justify-content: space-evenly;
        li{
            width: 100%;
            position: relative;
            /*height: 50px;*/
            margin-top: 30px;
            list-style-type:none;
            &>div{
                width: 120px;
                /*height: 50px;*/
                /*border: 1px #BFBFBF solid;*/
                border-radius: 5px;
                background: #fff;
                position: absolute;
                left: 50%;
                top: 4%;
                transform: translate(-50%, -50%);
                z-index: 10;
                span{
                    display: block;
                    width: 100px;
                    position: absolute;
                    left: 50%;
                    top: -4%;
                    transform: translate(-50%, -50%);
                    color: #666666;
                    text-align: center;
                    cursor: default;
                }
                .el-icon-check:before {
                    content: "\e611";
                    margin: 1px 0px 1px 0px;
                    display: inline-block;
                }
                .jt{
                    position: absolute;
                    left: 50%;
                    top: -10px;
                    margin-left: -10px;
                    display: block;
                    width: 0;
                    height: 0;
                    border-width: 0 10px 10px;
                    border-style: solid;
                    border-color: transparent transparent #BFBFBF;
                    &:before{
                        content: '';
                        position: absolute;
                        left: 50%;
                        top: 1px;
                        margin-left: -9px;
                        display: block;
                        width: 0;
                        height: 0;
                        border-width: 0 9px 9px;
                        border-style: solid;
                        border-color: transparent transparent #fff;
                    }
                }
                .yuan{
                    position: absolute;
                    top: -42px;
                    left: 50%;
                    margin-left: -12px;
                    width: 24px;
                    height: 24px;
                    background: #fff;
                    border: 2px #BFBFBF solid;
                    border-radius: 50%;
                }
            }
            &:after{
                content: '';
                width: 50%;
                height: 2px;
                position: absolute;
                left: 0;
                top: -30px;
                background: #BFBFBF;
            }
            &:before{
                content: '';
                width: 50%;
                height: 2px;
                position: absolute;
                left: 50%;
                top: -30px;
                background: #BFBFBF;
            }
            &.history{
                &>div{
                    /*border: 1px #1890FF solid;*/
                    span{
                        color: #1890FF;
                    }
                    .jt{
                        border-color: transparent transparent #1890FF;
                    }
                    .yuan{
                        border: 2px #1890FF solid;
                    }
                }
                &:after{
                    background: #1890FF;
                }
                &:before{
                    background: #1890FF;
                }
                &.last{
                    &:before{
                        background: #BFBFBF;
                    }
                }
            }
            &.activation{
                &>div{
                    border: 1px #1890FF solid;
                    span{
                        color: #1890FF;
                    }
                    .jt{
                        border-color: transparent transparent #1890FF;
                    }
                    .yuan{
                        border: 2px #1890FF solid;
                    }
                }
                &:after{
                    background: #1890FF;
                }
                &:before{
                    background: #1890FF;
                }
            }
            &.actived{
                &>div{
                    span{
                        color: #1890FF;
                    }
                    .yuan{
                        background: #fff;
                        color: #1890FF;
                        &:before{
                            position: absolute;
                            left: 50%;
                            top: 50%;
                            transform: translate(-50%, -50%);
                        }
                    }
                }
            }
            &.current{
                &>div{
                    /*background: #1890FF;*/
                    span{
                        /*color: #fff;*/
                    }
                    .jt{
                        &:before{
                            display: none;
                        }
                    }
                    .yuan{
                        background: #1890FF;
                        color: #fff;
                        &:before{
                            position: absolute;
                            left: 50%;
                            top: 50%;
                            transform: translate(-50%, -50%);
                        }
                    }
                }
            }
        }
    }

</style>